module.exports = __webpack_public_path__ + "img/culture3.98fe0ba5.jpg";